module.exports = __webpack_public_path__ + "static/media/loginBackground.ce8ecba3.png";